import { byMedia } from '../helpers/media';
const BOX_SIZING = {
  border: 'border-box',
  content: 'content-box'
};
export const boxSizing = byMedia(value => `box-sizing: ${BOX_SIZING[value] || value};`);